export const INITIAL_FILTERS = {
  occupation: "",
  education: "",
  marital: "",
  religion: "",
  minHeight: "",
  maxHeight: "",
  minAge: "",
  maxAge: "",
  radius: "",
  latitude: "",
  longitude: "",
  country: "",
  sort: "",
  is_web: "",
  userId: "",
  email: "",
  contactNo: "",
  gender: "",
  created_date_start: "",
  created_date_end: "",
  premium: "",
};

export const BACKEND_LIMIT = 15;

export const TH_CLASS =
  "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap";
export const TD_BASE = "px-6 py-4 whitespace-nowrap text-xs md:text-sm";
